import React, { useState } from 'react'
import { Spin, Row, Col, Form, Input, Button } from 'antd';

import Document from '../document/document.component';

import { insuredPersonValidationFormRules as rules } from '../../utils/form-rules';

import { colLayout, isValidCUITCUIL } from '../../utils/utils';
import { checkPolicyBelongsToCUIT } from '../../services/services';
import { INITIAL_STATE_INSURED_PERSON } from '../register/register.component';

const InsuredPersonValidationForm = ({ setIsInsuredPerson, setInsuredPerson }) => {

    const [form] = Form.useForm();

    const [validatingPolicy, setValidatingPolicy] = useState(false);

    const validatePolicy = (_, value, callback) => {
        if (!value) callback()

        else {
            //RegExp
            var result = /^[0-9]*$/.test(value);
            if (!result) {
                callback('Nro de póliza inválido')
            }

            //Tiene valor, son numeros. Chequear contra CUIT
            else {
                const document = form.getFieldValue("document");
                const policy = form.getFieldValue("policy");
                if ((document && isValidCUITCUIL(document))) {
                    setValidatingPolicy(true)
                    checkPolicyBelongsToCUIT(document, policy)
                        .then(axiosResponse => {
                            const { data } = axiosResponse.data
                            const json_response = JSON.parse(data)
                            const { Belongs: belongs, Person: person, IsUser: isUser } = json_response;
                            if (belongs) {
                                form.resetFields();
                                setInsuredPerson({ name: person, isUser, cuit: document })
                                setIsInsuredPerson(true);
                                callback()
                            }
                            else {
                                setInsuredPerson(INITIAL_STATE_INSURED_PERSON)
                                setValidatingPolicy(false)
                                callback('El nro de poliza no se correponde con el CUIT/CUIL ingresado')
                            }
                        })
                        .catch(err => {
                            setValidatingPolicy(false)
                            callback('Se produjo un error al validar la póliza. Inténtelo nuevamente')
                        })
                } else callback()
            }
        }
    }

    return (
        <Form
            form={form}
            name="insuredPersonValidationForm"
            layout="vertical"
            requiredMark={false}
        >
            <Spin tip="Validando póliza..." spinning={validatingPolicy}>
                <Row>
                    <Col {...colLayout}>
                        <Document form={form} />
                    </Col>

                    <Col {...colLayout}>
                        <Form.Item
                            label="Nro. Póliza"
                            name="policy"
                            extra={"Nro de póliza asociado al CUIT/CUIL"}
                            validateTrigger={false}
                            rules={[
                                ...rules.policy,
                                { validator: validatePolicy }
                            ]}
                            style={{ marginBottom: "0px" }}
                        >
                            <Input maxLength={7} size="large" />
                        </Form.Item>
                        <Button type="primary" htmlType="submit">VALIDAR</Button>
                    </Col>
                </Row>
            </Spin>
        </Form>
    );
}

export default InsuredPersonValidationForm;